import i18n from "../../../../constants/i18n";
import { AUDITOR_MY_AUDITING_MISTAKES_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getMyAuditingMistakesStore from "../../../../stores/auditor-store/my-auditing-mistakes-store";
import Et3Table from "../../../../core/et3-table";

const EventsData = withLiteObserverAndTheme(() => {
  const myMistakes = getMyAuditingMistakesStore().myMistakes.get();

  return (
    <Et3Table
      columns={AUDITOR_MY_AUDITING_MISTAKES_HEADERS}
      rows={myMistakes}
      title={i18n.get("EVENTS_COUNT")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_COUNT"}
    />
  );
});

export default EventsData;
